const asyncActionType = type => ({
    pending: `${type}_PENDING`,
    success: `${type}_SUCCESS`,
    error: `${type}_ERROR`
});

export const ADD_BOOKING = asyncActionType('ADD_BOOKING');
export const EDIT_BOOKING = asyncActionType('EDIT_BOOKING');
export const EDIT_BOOKING_CONTACTS = asyncActionType('EDIT_BOOKING_CONTACTS');
export const EDIT_BOOKING_COLOR = asyncActionType('EDIT_BOOKING_COLOR');
export const EDIT_BOOKING_PAYMENT_STATUS = asyncActionType('EDIT_BOOKING_PAYMENT_STATUS');
export const CHANNEL_BOOKING_DETAILS_BY_BOOKING_ID = asyncActionType('CHANNEL_BOOKING_DETAILS_BY_BOOKING_ID');
export const LOAD_BOOKING = asyncActionType('LOAD_BOOKING');
export const BOOKING_FLAG= 'BOOKING_FLAG';
export const CLEAR_BOOKING = 'CLEAR_BOOKING';
export const SAVE_SPECIAL_BOOKING_DATA = 'SAVE_SPECIAL_BOOKING_DATA';
export const CLEAR_SPECIAL_BOOKING_DATA = 'CLEAR_SPECIAL_BOOKING_DATA';
export const DELETE_BOOKING = asyncActionType('DELETE_BOOKING');
export const GET_BOOKING_BY_GUEST_ID = asyncActionType('GET_BOOKING_BY_GUEST_ID');
export const DELETE_BLOCK_DATE = asyncActionType('DELETE_BLOCK_DATE');
export const CHARGE_CALCULATION=asyncActionType('CHARGE_CALCULATION');
export const ADD_DISCOUNT=asyncActionType('ADD_DISCOUNT');
export const EDIT_DISCOUNT=asyncActionType('EDIT_DISCOUNT');
export const EDIT_DISCOUNT_BY_BOOKING_FORM = asyncActionType('EDIT_DISCOUNT_BY_BOOKING_FORM');
export const FETCH_DISCOUNT=asyncActionType('FETCH_DISCOUNT');
export const FETCH_DISCOUNT_BY_BOOKING = asyncActionType('FETCH_DISCOUNT_BY_BOOKING');
export const FETCH_BOOKING_BY_ID=asyncActionType('FETCH_BOOKING_BY_ID');
export const GET_FEES_TAXES=asyncActionType('GET_FEES_TAXES');
export const RESET_CHARGES='RESET_CHARGES';
export const RESET_DISCOUNT_BOOKING='RESET_DISCOUNT_BOOKING';
export const CLEAR_FEESTAXES = 'CLEAR_FEESTAXES';